<div
  class="notice rounded border border-dashed p-3"
  [ngClass]="{
    'bg-light-warning border-warning': severity() === 'warning',
    'bg-light-primary border-primary': severity() === 'primary',
    'bg-light-danger border-danger': severity() === 'danger',
    'bg-bg-light border-light': severity() === 'light',
  }"
  [class]="class()"
>
  <ng-content></ng-content>
</div>
